export enum SchoolBookingStatusEnum {
    BookingCreatedAwaitingApproval = 1,
    BookingUpdatedAwaitingApproval = 2,
    BookingCancelled = 3,
    BookingApproved = 4,
    BookingClaimed = 5
}
